import efas.common.version
import kotlin.js.Date

fun startLogs() {
    println(
        """
██████████                 ████ ███      █████                            
░░███░░░░░█                ░░███░░░      ░░███                             
 ░███  █ ░████████   ███████░███████ █████░███████                         
 ░██████ ░░███░░███ ███░░███░██░░██████░░ ░███░░███                        
 ░███░░█  ░███ ░███░███ ░███░███░██░░█████░███ ░███                        
 ░███ ░   ░███ ░███░███ ░███░███░███░░░░██░███ ░███                        
 █████████████ ████░░█████████████████████████ █████                       
░░░░░░░░░░░░░ ░░░░░ ░░░░░██░░░░░░░░░░░░░░░░░░ ░░░░░                        
                    ███ ░███                                               
                   ░░██████                                                
                    ░░░░░░                                                 
    ██████                                                                 
   ███░░███                                                                
  ░███ ░░██████ ████████      ██████       █████  ██████ ████████   ███████
 ██████████░░██░░███░░███    ░░░░░███     ███░░  ███░░██░░███░░███ ███░░███
░░░███░░███ ░███░███ ░░░      ███████    ░░█████░███ ░███░███ ░███░███ ░███
  ░███ ░███ ░███░███         ███░░███     ░░░░██░███ ░███░███ ░███░███ ░███
  █████░░██████ █████       ░░████████    ██████░░██████ ████ ████░░███████
 ░░░░░  ░░░░░░ ░░░░░         ░░░░░░░░    ░░░░░░  ░░░░░░ ░░░░ ░░░░░ ░░░░░███
                                                                   ███ ░███
                               A free portable tutor              ░░██████ 
                                    ©${Date().getFullYear()}    v${version.padEnd(12)}         ░░░░░░  
        """.trimIndent()
    )

    val licenseTexts = listOf(
        "License Attributions:",
        "Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com\n\tLicense - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)",
        "Font made from http://www.onlinewebfonts.com Online Web Fonts is licensed by CC BY 3.0"
    )

    println(licenseTexts.joinToString("\n\n"))
}